// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonTertiaryToggle = 2;